import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import { SetBranchAuthFormAction, GetBranchAuthorizationAction } from "../../redux/actions/branchAction";

function BranchAuth() {
    const [loading, setloading] = useState([]);
    const [selectedRow, setselectedRow] = useState([]);
    const dispatch = useDispatch();

    const getBranchAuthorization = async () => {
        await dispatch(GetBranchAuthorizationAction("zbizgateway//nonFin/getBranchAuthMatrix"));
    };

    useEffect(() => {
        getBranchAuthorization();
        setloading(false);
    }, []); // eslint-disable-line

    const branchAuthorizationData = useSelector((state) => state?.branchSlice?.baranchAuthDetails);

    const onRowSelect = (event) => {
        dispatch(SetBranchAuthFormAction(event?.data));
    };

    const statusBody = (rowData) => {
        return <div>{rowData?.isSequential === "Y" ? "Yes" : "No"}</div>;
    };

    return (
        <div>
            <div className="card p-datatable-sm">
                <DataTable
                    header="Branch Authorization "
                    selection={selectedRow}
                    onSelectionChange={(e) => setselectedRow(e.value)}
                    selectionMode="single"
                    dataKey="authMatrixHeadId"
                    onRowSelect={onRowSelect}
                    loading={loading}
                    paginator
                    rows={5}
                    value={branchAuthorizationData}
                    emptyMessage="No data found."
                >
                    <Column filter field="tblProduct.masterProductName" header="Master Product Name" />
                    <Column filter field="fromAmount" header="From Amount" />
                    <Column filter field="toAmount" header="To Amount" />
                    <Column filter field="isSequential" body={statusBody} header="Sequential" />
                </DataTable>
            </div>
        </div>
    );
}

export default BranchAuth;
